import axiosInstance from "@/services/axiosInterceptor";

export async function getTaskById(id) {
  try {
    const response = await axiosInstance.get(`common/tasks?taskIds=${id.join()}`);
    const data = response?.data?.rows;
    return data;
  } catch (error) {
    throw error;
  }
}

export async function markTaskAsCompleted(taskId) {
  try {
    const response = await axiosInstance.post(`common/task/${taskId}/complete`);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
